// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1uIEL","select":"Header_select__3B7Vp","clinic":"Header_clinic__3WhyG"};